import { render, staticRenderFns } from "./TimeSinceLastVisit.vue?vue&type=template&id=3ab05a41&scoped=true"
import script from "./TimeSinceLastVisit.vue?vue&type=script&lang=ts"
export * from "./TimeSinceLastVisit.vue?vue&type=script&lang=ts"
import style0 from "./TimeSinceLastVisit.vue?vue&type=style&index=0&id=3ab05a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab05a41",
  null
  
)

export default component.exports